module.exports = __webpack_public_path__ + "static/12-b210556de4869937731ed3cfd65c08d9.jpeg";